import { useSentry } from "@starrez/starryutils";
import React, { useEffect } from "react";
import { AppError } from "../../../context/ErrorContext";
import { strings } from "../../../localisation";
import { ErrorDisplayDiv, ErrorMessageP, ErrorMessageTitleH2 } from "./ErrorDisplay.styles";

declare let ERRORS_SEND_TO_SENTRY: boolean;

export interface IErrorDisplayProps {
    error?: AppError;
}

export const ErrorDisplay = ({ error }: IErrorDisplayProps) => {

    const { captureException } = useSentry();

    useEffect(() => {
        if (ERRORS_SEND_TO_SENTRY && error) {
            captureException(error);
        }
    }, [error]);

    return (
        <ErrorDisplayDiv>

            <ErrorMessageTitleH2>
                {strings.Message_Error_General}
            </ErrorMessageTitleH2>

            <ErrorMessageP>
                {strings.Message_Error_GeneralDescription}
            </ErrorMessageP>

        </ErrorDisplayDiv>
    );
};
